import { Layer, Source } from 'react-map-gl';
import { useEffect, useMemo, useState } from 'react';
import { type LineString, featureCollection } from '@turf/helpers';
import { getLayerBeforeId, polylinesBottomId, polylinesTopId } from '../../utils/layers';
import useMap from '../../hooks/useMap';

const sourceId = 'empty-polyline-source';

type Props = {};

const EmptyPolylineLayers = ({}: Props) => {
  const map = useMap();
  const [currentStyle, setCurrentStyle] = useState<string | undefined>();
  const data = useMemo(() => featureCollection<LineString>([]), []);

  /**
   * HACK (DISCO-17246): this forces a re-render when the map style changes.
   * The map object's style is not updated when the style changes (sometimes), causing `getLayerBeforeId` to return layer values
   * that may not be valid with the map's current style.
   * By forcing a re-render when style changes, we ensure that the beforeId is updated to the correct value.
   */
  useEffect(() => {
    const handleStyleData = () => {
      const newStyle = map?.getStyle()?.name ?? undefined;
      if (newStyle !== currentStyle) {
        setCurrentStyle(newStyle);
      }
    };
    map?.on('styledata', handleStyleData);
    return () => {
      map?.off('styledata', handleStyleData);
    };
  }, [map, currentStyle]);

  return (
    <Source id={sourceId} type="geojson" data={data}>
      <Layer id={polylinesTopId} beforeId={getLayerBeforeId(map, polylinesTopId)} type="symbol" source={sourceId} />
      <Layer id={polylinesBottomId} beforeId={polylinesTopId} type="symbol" source={sourceId} />
    </Source>
  );
};

export default EmptyPolylineLayers;
